<template>
    <div class="Visitor">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Visitor__container">
                <video class="Visitor__movie" ref="movie">
                    <source src="https://meneath-v2.dpt.media/static/overlay_green.mp4" type="video/mp4">
                </video> 
                <div class="Visitor__button" @click="onClick()" v-if="sync">Sync</div>
            </div>
        </transition>
    </div>
</template>

<script>

import { Howl, Howler } from 'howler'

export default {

    name: 'Visitor',
    data: ()=>({
        is_playing: false,
        sync: true,
        ready: false,
        delay: 1,
        loop: 0
    }), 
    beforeDestroy() {
        this.$socket.emit('userLeaveRoom', this.$room)   
    },
    created(){
        this.$room = this.$route.params.room ? this.$route.params.room : 350
        console.log('Visitor --- ');
    },
    mounted() {
        console.log('created '+ this.$room);
        console.log('xxxx');
        this.$sound = new Howl({
            src: [require('@/commons/sound/sound.mp3')],
            // autoplay: true,
            volume: 1
        })
        TweenMax.delayedCall(this.delay, ()=>{
            this.$refs.movie.muted = true
            // this.$id = this.$sound.play()
            if(this.$socket.connected)
                this.$socket.emit('joinSession', this.$room, 'visitor')
      })
    },
    computed: {
        sync_time() { return this.$store.getters['socket/sync_time'] },
    },
    watch: {
        sync_time(nw, od) {

            // console.log(Date.now()-nw.utc);

            // 66.534685

            // const movie_cue = Math.floor((this.$refs.movie.currentTime * 10000))/10000


            
            // console.log(this.loop);

            if(this.loop == 0) {
               
                const utc = Date.now()-nw.utc
                const adj = utc/1000
                const cue = nw.time + adj + .2  
  
                this.$refs.movie.currentTime = cue
                this.$sound.seek(cue, this.$id)
            }

            this.loop += 1
            if(this.loop ==10) 
                this.loop = 0


            // const diff = Math.abs(nw.time - this.$refs.movie.currentTime)

            // // console.log(diff + ' == ');

            // const cue = nw.time + .2    
            // if(diff > 1) {
            //     this.$refs.movie.currentTime = cue
            //     this.$sound.seek(cue, this.$id)
            // }

            
        },
    },
    methods: {
        onClick() {
            this.sync = false
            this.$refs.movie.play()
            this.$id = this.$sound.play()
            this.$sound.seek(0, this.$id)
        },
        enter(done) {
            done()
        },
        leave(done) {
            done()
        },    
    }
    
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Visitor
    overflow hidden
    position absolute
    width 100vw
    height 100%
    color white
    background white

    &__container
        
        width 100%
        height 100%
        position relative
        display flex 
        justify-content center
        align-items center

    &__button 
        width 80px
        height 80px
        border-radius 50%
        background black
        border 2px solid white
        z-index 2
        cursor pointer
        display flex 
        justify-content center
        align-items center

    &__movie
        overflow hidden
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        background-color white
        width 80%

    // video 
        // width 100%   

</style>